import { Component, OnInit, Inject } from '@angular/core';
import 'style-loader!./common.component.scss';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'dialog-pdf',
  templateUrl: './pdf.component.html',
})
export class PDFComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IPDF,
    public dialogRef: MatDialogRef<PDFComponent>,

  ) {
  }
  
  ngOnInit() {
    if (this.data.content) {
        $("#dialog-pdf .dialog-content").append(this.data.content);
     }
  }
  CloseMe(returnedValue) {
    this.dialogRef.close({
      value: returnedValue
    });
  }
}



export interface IPDF {
  title;
  content;
  footer;
  source;
 }


// WEBPACK FOOTER //
// ./src/app/theme/shared/dialogs/pdf.component.ts